const ProductActions = require('actions/ProductActions');


const executeMergeActionSideEffects = (reducerName, key, value) => {
    switch (reducerName) {
        case 'page.product': {
            ProductActions.executeMergeActionSideEffects(key, value);

            break;
        }
        default: {
            // Should do nothing always!
            break;
        }
    }
};

const merge = (reducerName, key, value) => {
    executeMergeActionSideEffects(reducerName, key, value);
    const action = {
        type: `${reducerName}_MERGE`,
        payload: {
            key,
            value
        }
    };

    return action;
};

module.exports = {
    executeMergeActionSideEffects,
    merge
};
